import { Mark } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { indentation } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/indentation.js';

/* eslint-disable */
class Indentation extends Mark {
  get name() {
    return 'indentation';
  }

  get schema() {
    return { ...indentation,
      parseDOM: [{
        tag: 'div.fabric-editor-indentation-mark',

        getAttrs(dom) {
          const level = +(dom.getAttribute('data-level') || '0');
          return {
            level: level > 6 ? 6 : level < 1 ? false : level
          };
        }

      }],

      toDOM(mark) {
        return ['div', {
          class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
          'data-level': mark.attrs.level,
          style: 'margin-left:' + mark.attrs.level * 30 + 'px'
        }, 0];
      }

    };
  }

}

export default Indentation;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/marks/Indentation.js